import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { passwordProblem } from "../lib/password";
import { useAuth } from "../context/AuthContext";
import AuthLayout from "../components/auth/AuthLayout";
import {
  errorStyle,
  fieldStyle,
  formStyle,
  inputStyle,
  labelStyle,
  primaryButtonStyle,
  subtitleStyle,
  titleStyle,
  colors,
} from "../components/auth/authStyles";

// Landing page for the link in the "reset password" email. Supabase signs the
// user in from the link, so here we only need to set the new password.
const ResetPassword = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const problem = passwordProblem(password, confirm);
    if (problem) {
      setError(problem);
      return;
    }
    setSubmitting(true);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setSubmitting(false);
    if (updateError) {
      setError(updateError.message);
      return;
    }
    navigate("/account", { replace: true });
  };

  if (loading) return <div style={{ minHeight: "100vh" }} />;

  return (
    <AuthLayout eyebrow="ACCOUNT" body="Choose a new password for your 900 Pro Shop account.">
      {!user ? (
        <div style={formStyle}>
          <h1 style={titleStyle}>Link expired</h1>
          <p style={subtitleStyle}>
            This reset link is invalid or has expired.{" "}
            <Link to="/login" style={{ color: colors.teal, fontWeight: 600 }}>
              Request a new one
            </Link>
            .
          </p>
        </div>
      ) : (
        <form style={formStyle} onSubmit={handleSubmit}>
          <div>
            <h1 style={titleStyle}>Set a new password</h1>
            <p style={subtitleStyle}>For {user.email}</p>
          </div>
          {error && (
            <div style={errorStyle} role="alert">
              {error}
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: "1.1rem" }}>
            <div style={fieldStyle}>
              <label htmlFor="new-password" style={labelStyle}>
                New password
              </label>
              <input
                id="new-password"
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="auth-input"
                style={inputStyle}
              />
            </div>
            <div style={fieldStyle}>
              <label htmlFor="confirm-password" style={labelStyle}>
                Confirm new password
              </label>
              <input
                id="confirm-password"
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="auth-input"
                style={inputStyle}
              />
            </div>
          </div>
          <button
            type="submit"
            style={{ ...primaryButtonStyle, opacity: submitting ? 0.7 : 1 }}
            disabled={submitting}
          >
            {submitting ? "Saving..." : "Save password"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
};

export default ResetPassword;
